import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";
import moment from "moment";

const getWheelLuckTransaction = async (filters) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };

  const { page, searchTerm = "", startDate = null, endDate = null } = filters;
  const encodedSearchTerm = encodeURIComponent(searchTerm);
  let encodedStartDate = "";
  let encodedEndDate = "";
  if (startDate) {
    encodedStartDate = moment
      .utc(startDate)
      .add(1, "day")
      .endOf("day")
      .toISOString();
  }
  if (endDate) {
    encodedEndDate = moment
      .utc(endDate)
      .add(1, "day")
      .endOf("day")
      .toISOString();
  }

  let url = `${SERVER_API_URL}/wheel_luck/transactions?page=${page}&search=${encodedSearchTerm}`;
  if (encodedStartDate) {
    url += `&startDate=${encodeURIComponent(encodedStartDate)}`;
  }
  if (encodedEndDate) {
    url += `&endDate=${encodeURIComponent(encodedEndDate)}`;
  }
  // Make the API request
  const result = await axios.get(url, config);
  return result;
};

export { getWheelLuckTransaction };
